"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIGeneration = exports.EAIGenerationStatus = void 0;
const index_1 = require("../../index");
var EAIGenerationStatus;
(function (EAIGenerationStatus) {
    EAIGenerationStatus["QUEUED"] = "queued";
    EAIGenerationStatus["GENERATING"] = "generating";
    EAIGenerationStatus["COMPLETE"] = "complete";
    EAIGenerationStatus["ERROR"] = "error";
})(EAIGenerationStatus || (exports.EAIGenerationStatus = EAIGenerationStatus = {}));
class AIGeneration extends index_1.Base {
    user_id = '';
    agent_label = '';
    agent_id = '';
    version_id = '';
    query = '';
    variables = {};
    status;
    provider = '';
    model = '';
    currentResponse = '';
    error = '';
    generationStartMs;
    generationCompleteMs;
    errorMs;
    usage = {};
    threadRef = null;
    assistantMsgPath = '';
    generatedImages = [];
    outputData = null;
    _m = ['id', 'agent_label', 'agent_id', 'version_id', 'user_id', 'query', 'status', 'provider', 'model'];
    _s = ['id', 'agent_label', 'agent_id', 'version_id', 'user_id', 'query', 'status', 'provider', 'model', 'last_date'];
    constructor(data, olMap) {
        super('ai_generations', 20);
        (0, index_1.setObjectProperties)(this, data, olMap, AIGeneration);
    }
    toString() {
        return this.query?.substring(0, 50) || `AI ${this.agent_label}`;
    }
    accumulateUsage(incoming) {
        const u = this.usage ?? {};
        this.usage = {
            ...incoming,
            totalInputTokens: (u.totalInputTokens ?? 0) + (incoming.inputTokens ?? 0),
            totalOutputTokens: (u.totalOutputTokens ?? 0) + (incoming.outputTokens ?? 0),
            totalDurationMs: (u.totalDurationMs ?? 0) + (incoming.durationMs ?? 0),
            generationCount: (u.generationCount ?? 0) + 1,
        };
    }
    toJSON() {
        const r = super.toJSON();
        r.last_date = this.last_date || this.date;
        if (this.threadRef)
            r.threadRef = this.threadRef;
        return r;
    }
}
exports.AIGeneration = AIGeneration;
index_1.olm.ai_generations = (ref, map) => {
    return new AIGeneration(ref, map);
};
